module.exports = __webpack_public_path__ + "static/media/mohammadshuvo.33dcdd9e.jpg";